<template>
  <span class="status-badge" :class="statusClass">
    <span class="status-dot"></span>
    {{ text }}
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    statusClass() {
      const normalizedStatus = (this.status || this.text || '').toLowerCase().trim();

      if (normalizedStatus.includes('aprovado') || normalizedStatus.includes('concluido') || normalizedStatus.includes('concluído') || normalizedStatus.includes('faturado')) {
        return 'status-success';
      }
      if (normalizedStatus.includes('pendente') || normalizedStatus.includes('aguardando') || normalizedStatus.includes('análise') || normalizedStatus.includes('analise')) {
        return 'status-warning';
      }
      if (normalizedStatus.includes('cancelado') || normalizedStatus.includes('recusado') || normalizedStatus.includes('rejeitado') || normalizedStatus.includes('bloqueado')) {
        return 'status-danger';
      }
      if (normalizedStatus.includes('rascunho') || normalizedStatus.includes('draft')) {
        return 'status-muted';
      }
      if (normalizedStatus.includes('processando') || normalizedStatus.includes('em andamento') || normalizedStatus.includes('aberto')) {
        return 'status-info';
      }

      return 'status-default';
    },
  },
};
</script>

<style lang="scss" scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 100px;
  white-space: nowrap;
  text-transform: capitalize;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-success {
  background: rgba(23, 127, 70, 0.1);
  color: #177f46;

  .status-dot {
    background: #177f46;
  }
}

.status-warning {
  background: rgba(245, 159, 11, 0.1);
  color: #b45309;

  .status-dot {
    background: #f59f0b;
  }
}

.status-danger {
  background: rgba(201, 66, 67, 0.1);
  color: #c94243;

  .status-dot {
    background: #c94243;
  }
}

.status-info {
  background: rgba(93, 84, 212, 0.1);
  color: #5d54d4;

  .status-dot {
    background: #5d54d4;
  }
}

.status-muted {
  background: rgba(95, 100, 114, 0.1);
  color: #5f6472;

  .status-dot {
    background: #5f6472;
  }
}

.status-default {
  background: var(--sf-surface-secondary, #f8f9fc);
  color: var(--sf-text-secondary, #3d4250);

  .status-dot {
    background: var(--sf-text-muted, #5f6472);
  }
}

body.dark-layout {
  .status-success {
    background: rgba(23, 127, 70, 0.2);
    color: #4ade80;

    .status-dot {
      background: #4ade80;
    }
  }

  .status-warning {
    background: rgba(245, 159, 11, 0.2);
    color: #fbbf24;

    .status-dot {
      background: #fbbf24;
    }
  }

  .status-danger {
    background: rgba(201, 66, 67, 0.2);
    color: #f87171;

    .status-dot {
      background: #f87171;
    }
  }

  .status-info {
    background: rgba(93, 84, 212, 0.2);
    color: #a5b4fc;

    .status-dot {
      background: #a5b4fc;
    }
  }

  .status-muted {
    background: rgba(148, 163, 184, 0.2);
    color: #94a3b8;

    .status-dot {
      background: #94a3b8;
    }
  }

  .status-default {
    background: rgba(255, 255, 255, 0.1);
    color: #e2e8f0;

    .status-dot {
      background: #94a3b8;
    }
  }
}
</style>
